var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.changed)?_c('input',{on:{"change":function($event){return _vm.changeFun($event)}}}):_c('i')}
var staticRenderFns = []

export { render, staticRenderFns }